export function showConfigError(message: string): void {
  const loadingEl = document.getElementById('app-loading');
  if (loadingEl) {
    loadingEl.innerHTML = `
      <style>
        .cfg-error-btn { position:relative; overflow:hidden; }
        .cfg-error-btn::after { content:''; position:absolute; inset:0; background:var(--mat-sys-on-primary); opacity:0; transition:opacity 0.15s; }
        .cfg-error-btn:hover::after { opacity:0.08; }
        .cfg-error-btn:focus-visible::after { opacity:0.12; }
        .cfg-error-btn:focus-visible { outline:2px solid var(--mat-sys-on-primary); outline-offset:2px; }
      </style>
      <img src="/assets/images/ok-logo.svg" alt="OK Logo" />
      <p style="color:var(--mat-sys-error);animation:none;font-weight:bold;">Siden kunne ikke indlæses</p>
      <button
        id="cfg-error-reload-btn"
        class="cfg-error-btn"
        style="background:var(--mat-sys-primary);color:var(--mat-sys-on-primary);border:none;border-radius:var(--border-radius-components);padding:10px 24px;font-size:0.875rem;font-weight:700;font-family:inherit;letter-spacing:0.1px;cursor:pointer;margin-block: 0.5rem;"
      >Prøv igen</button>
      <p style="font-size:0.875rem;color:var(--mat-sys-on-surface);animation:none;">${message}</p>
      <p style="font-size:0.75rem;color:var(--mat-sys-on-surface-variant);animation:none;">Kontakt supporten hvis problemet fortsætter.</p>
    `;

    document.getElementById('cfg-error-reload-btn')?.addEventListener('click', () => {
      location.reload();
    });
  }
}
